module.exports = __webpack_public_path__ + "img/coindesk.2e5a5fd4.png";